import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ListingCard from "./ListingCard";
import "../../style/ListingCard.css";

// responsive grid of listing cards with empty state
function ListingCardGrid({ listings, darkMode, onCardClick }) {
  const { t } = useTranslation();

  if (!listings || listings.length === 0) {
    return (
      <div className={`listing-grid__empty ${darkMode ? "dark" : "light"}`}>
        <p>{t("No listings found")}</p>
      </div>
    );
  }

  return (
    <div className="listing-grid">
      {listings.map((listing) => (
        <ListingCard
          key={listing.id}
          listing={listing}
          darkMode={darkMode}
          onClick={onCardClick}
        />
      ))}
    </div>
  );
}

ListingCardGrid.propTypes = {
  listings: PropTypes.array.isRequired,
  darkMode: PropTypes.bool,
  onCardClick: PropTypes.func,
};

export default ListingCardGrid;
